import Icon from '@mdi/react';
import React from 'react';
import { mdiStar } from '../../assets/icons/mdiIcons';
import { CMS_THEME } from '../../common/enums';

interface StarColors {
  filledStar: string;
  emptyStar: string;
  emptyStarStroke: string;
}

const starColors: Record<CMS_THEME.LIGHT | CMS_THEME.DARK | CMS_THEME.NEUTRAL, StarColors> = {
  [CMS_THEME.LIGHT]: {
    filledStar: '#CC6200',
    emptyStar: '#EAEAEA',
    emptyStarStroke: '#CC6200',
  },
  [CMS_THEME.DARK]: {
    filledStar: '#FAA018',
    emptyStar: '#464646',
    emptyStarStroke: '#FAA018',
  },
  [CMS_THEME.NEUTRAL]: {
    filledStar: '#CC6200',
    emptyStar: '#EAEAEA',
    emptyStarStroke: '#CC6200',
  },
};

export const RatingStars = ({
  rating,
  theme,
  starSize = 0.8,
}: {
  rating: number;
  theme: CMS_THEME;
  starSize?: number;
}) => {
  const stars = [];
  const { filledStar, emptyStar, emptyStarStroke } =
    starColors[theme as CMS_THEME.LIGHT | CMS_THEME.DARK];

  const srMessage = `rated ${rating} stars`;

  for (let i = 0; i < 5; i++) {
    if (i < Math.floor(rating)) {
      // Fully filled star
      stars.push(
        <Icon
          // @ts-ignore
          viewBox="-1 -1 27 25"
          key={i}
          path={mdiStar}
          size={starSize}
          style={{ color: filledStar, stroke: emptyStarStroke }}
        />,
      );
    } else if (i < rating) {
      // Partially filled star
      stars.push(
        <div
          key={i}
          style={{
            position: 'relative',
            display: 'flex',
          }}
        >
          <Icon
            // @ts-ignore
            viewBox="-1 -1 27 25"
            path={mdiStar}
            size={starSize}
            style={{
              color: filledStar,
              // Subtract 2 is subjective to make the star look better.
              clipPath: `inset(0 ${100 - (rating - Math.floor(rating)) * 100}% 0 0)`,
              position: 'absolute',
            }}
          />
          <Icon
            // @ts-ignore
            viewBox="-1 -1 27 25"
            path={mdiStar}
            size={starSize}
            style={{
              stroke: emptyStarStroke,
              color: emptyStar,
            }}
          />
        </div>,
      );
    } else {
      // Empty star
      stars.push(
        <Icon
          key={i}
          // @ts-ignore
          viewBox="-1 -1 27 25"
          path={mdiStar}
          size={starSize}
          style={{ stroke: emptyStarStroke, color: emptyStar }}
        />,
      );
    }
  }

  return (
    <div className="pds-flex pds-items-center pds-gap-2">
      <span className="pds-sr-only">{srMessage}</span>
      {stars}
    </div>
  );
};
